import { useEffect, useState } from 'react'
import { useSyncQueueStore } from '@/lib/helpers/bgSync/useSyncQueueStore.ts'

export function useAnimateQueueCount() {
  const [isAnimating, setIsAnimating] = useState(false)
  const [isVisible, setIsVisible] = useState(false)
  const { data: queueRequests } = useSyncQueueStore()
  const queueCount = queueRequests.length ?? 0

  useEffect(() => {
    if (queueCount > 0) {
      setIsAnimating(true)
      setIsVisible(true)
      const timer = setTimeout(() => {
        setIsAnimating(false)
      }, 5000)
      const timer2 = setTimeout(() => {
        setIsVisible(false)
      }, 10000)
      return () => {
        clearTimeout(timer)
        clearTimeout(timer2)
      }
    }
  }, [queueCount])

  return { isAnimating, isVisible, queueCount }
}
